/**
 * Align with backend ArtByggErp.Domain.Enums.CooperationStatusEnum (string enum in API).
 * Numeric values used in app model for comparisons.
 */
export enum CooperationStatusEnum {
  Pending = 0,
  Accepted = 1,
  Rejected = 2,
  Deactivated = 3
}

const statusStringToNumber: Record<string, number> = {
  Pending: CooperationStatusEnum.Pending,
  Accepted: CooperationStatusEnum.Accepted,
  Rejected: CooperationStatusEnum.Rejected,
  Deactivated: CooperationStatusEnum.Deactivated
};

export function cooperationStatusFromApi(status: string | number): number {
  if (typeof status === 'number') return status;
  return statusStringToNumber[status] ?? CooperationStatusEnum.Pending;
}
